<template>
  <div>
    <div class="top_text">
      <v-icon>beenhere</v-icon><span>사이즈별 리포트</span>
      <div class="select_ad">
        <div class="select" v-for="(data, key, index) in radioData" :key="key">
          <input type="radio" name="ad_radio" v-model="checkRadio"
            :key="index" :value="key" @change="radioClick"/>
          <span :key="index" @click="rTextClick(key)">{{key}}</span>
        </div>
      </div>
    </div>
    <div class="topTableWrap">
      <SizeTable
        :checkRadio="checkRadio"
        :viewData="viewData">
      </SizeTable>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapMutations } from 'vuex'

  import SizeTable from './SizeTable'

  export default {
    name: 'size_imp',
    props: {
      clearSelectedDate: Function,
      viewData: Array
    },
    components: {
      SizeTable
    },
    data () {
      return {
        radioData: {},
        checkRadio: ''
      }
    },
    methods: {
      ...mapMutations([
        'setCurrentAdKnd'
      ]),
      radioClick () {
        this.clearSelectedDate()
        this.setCurrentAdKnd(this.checkRadio)
      },
      rTextClick (val) {
        if (this.checkRadio === val) return
        this.checkRadio = val
        this.radioClick()
      }
    },
    mounted () {
      if (this.viewData.length === 0) return
      this.radioData = _.groupBy(this.viewData, 'ad_knd_nm')
      this.checkRadio = _.values(this.radioData)[0][0].ad_knd_nm
      this.setCurrentAdKnd(this.checkRadio)
      window.scroll(0, 0)
      document.body.scrollTop = 0
    },
    watch: {
      viewData (val) {
        this.radioData = _.groupBy(this.viewData, 'ad_knd_nm')
        this.checkRadio = _.values(this.radioData)[0][0].ad_knd_nm
        this.setCurrentAdKnd(this.checkRadio)
      }
    }
  }
</script>

<style scoped>
  .top_text {
    display: inline-block;
  }
  .sortRight {
    text-align: right;
    padding-right: 15px;
  }
  .select {
    display: inline-block;
  }
  .select_ad {
    margin-left: 20px;
    display: inline-block;
  }
  .select_ad input, .select_ad span {
    cursor: pointer;
  }

  @media screen and (max-width: 600px){
    .select_ad {
      display: block;
      margin-left: 5px;
    }
  }
</style>


// WEBPACK FOOTER //
// SizeImp.vue?4dcc4805